module.exports = __webpack_public_path__ + "static/media/erinformation.1a2d1c38.svg";